import type {Component} from 'typings/portaro.fe.types';
import type {Rating, RichRecord} from 'typings/portaro.be.types';
import type {IOnInit} from 'angular';
import type RatingDataService from './rating.data-service';
import type FinishedResponseInteractionService from '../../commons/services/finished-response-interaction.service';
import {isExceptionResponseOf} from '../../commons/conversation/modal-utils';
import {exceptionTypes} from '../../commons/constants/portaro.constants';

export class KpRatingComponentController implements KpRatingComponentBindings, IOnInit {
    public record: RichRecord;
    public rating: Rating;
    public isEnabled = true;

    /*@ngInject*/
    constructor(private ratingDataService: RatingDataService, private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async $onInit(): Promise<void> {
        try {
            this.rating = await this.ratingDataService.getById(this.record.id);
        } catch (exceptionResponse) {
            if (isExceptionResponseOf(exceptionResponse, exceptionTypes.FEATURE_NOT_ENABLED_EXCEPTION)) {
                this.isEnabled = false;
            }
        }
    }

    public async rate() {
        try {
            const response = await this.ratingDataService.createRating(this.record.id, this.rating.value);
            this.rating = response.savedObject;
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedInModalWindow(exceptionResponse);
        }
    }
}

/**
 * @ngdoc component
 * @name kpRating
 * @module uc.record
 *
 * @param {Record=} record
 *
 * @description
 *
 *
 */
export default class KpRatingComponent implements Component<KpRatingComponentBindings> {
    public static componentName = 'kpRating';

    public templateUrl = require('./kp-rating.tpl.ftl');

    public bindings = {
        record: '<',
    } as const;

    public controller = KpRatingComponentController;
}

interface KpRatingComponentBindings {
    record?: RichRecord;
}